import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { t } from '../utils/translations';
import { Ticket, Clock, CheckCircle, XCircle } from 'lucide-react';

export default function StatCards({ stats }) {
  const { lang } = useLang();
  const cards = [
    { key: 'total_tickets', value: stats?.total || 0, icon: Ticket, color: '#F77F00' },
    { key: 'in_progress_tickets', value: stats?.in_progress || 0, icon: Clock, color: '#F77F00' },
    { key: 'resolved_tickets', value: stats?.resolved || 0, icon: CheckCircle, color: '#22C55E' },
    { key: 'closed_tickets', value: stats?.closed || 0, icon: XCircle, color: '#6B7280' },
  ];

  return (
    <div data-testid="stat-cards" className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6">
      {cards.map(card => {
        const Icon = card.icon;
        return (
          <div key={card.key} data-testid={"stat-" + card.key} className="apollo-card p-3 sm:p-5 flex items-center justify-between gap-2 min-w-0">
            <div className="min-w-0 flex-1">
              <p className="text-[10px] sm:text-xs font-medium uppercase tracking-wider mb-1 truncate" style={{ color: '#9CA3AF' }}>{t(card.key, lang)}</p>
              <p className="text-2xl sm:text-3xl font-bold text-white leading-none">{card.value}</p>
            </div>
            <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: card.color + '20' }}>
              <Icon size={18} style={{ color: card.color }} className="sm:hidden" />
              <Icon size={22} style={{ color: card.color }} className="hidden sm:block" />
            </div>
          </div>
        );
      })}
    </div>
  );
}
